import { Box, Typography, useTheme, Chip, Alert, Snackbar, Avatar } from '@mui/material';
import { DatabaseTable } from '../../../shared/components/ui/DatabaseTable';
import { Button } from '../../../shared/components/ui/Button';
import { useVehicle } from '../context/useVehicle';
import { VEHICLE_TYPE_TRANSLATIONS } from '../constants/vehicleConstants';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

export default function VehicleList() {
  const theme = useTheme();
  const { 
    vehicles, 
    isLoading, 
    error, 
    handleCreate, 
    handleView, 
    handleCloseError 
  } = useVehicle();

  const columns = [
    { 
      field: 'foto', 
      headerName: 'Foto', 
      width: 80,
      renderCell: (params: any) => (
        <Avatar 
          src={params.value} 
          sx={{ width: 40, height: 40, bgcolor: '#E0E7EF' }}
        >
          <DirectionsCarIcon sx={{ fontSize: 20, color: '#9CA3AF' }} />
        </Avatar>
      )
    },
    { 
      field: 'marca', 
      headerName: 'Marca', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontWeight={600} fontSize={14}>
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'modelo', 
      headerName: 'Modelo', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'tipo', 
      headerName: 'Tipo', 
      width: 100,
      renderCell: (params: any) => (
        <Chip 
          label={VEHICLE_TYPE_TRANSLATIONS[params.value] || params.value} 
          size="small"
          color="secondary"
          variant="outlined"
        />
      )
    },
    { 
      field: 'placa', 
      headerName: 'Placa', 
      width: 120,
      renderCell: (params: any) => (
        <Typography 
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 600
          }}
        >
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'ano', 
      headerName: 'Ano', 
      width: 80,
      renderCell: (params: any) => (
        <Chip 
          label={params.value} 
          size="small"
          color="primary"
          variant="outlined"
        />
      )
    },
    { 
      field: 'cor', 
      headerName: 'Cor', 
      width: 100,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'tenantName', 
      headerName: 'Empresa', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
  ];

  return (
    <>
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      <Box style={{ 
        background: theme.palette.background.paper, 
        borderRadius: 16, 
        padding: 32, 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
        maxWidth: '100%', 
        margin: '0 auto' 
      }}>
        <PageHeader onCreate={handleCreate} isLoading={isLoading} />
        <DatabaseTable
          rows={vehicles}
          columns={columns}
          loading={isLoading}
          onView={handleView}
          hideDelete
          hideEdit
        />
      </Box>
    </>
  );
}

function PageHeader({ onCreate, isLoading }: { onCreate: () => void; isLoading: boolean }) {
  const theme = useTheme();
  
  return (
    <Box style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: 24 
    }}>
      <Box>
        <Typography variant='h4' color={theme.palette.text.primary}>Veículos</Typography>
        <Typography variant='caption' color={theme.palette.text.secondary}>
          Gerencie os veículos cadastrados no sistema
        </Typography>
      </Box>
      <Button
        variant="contained"
        onClick={onCreate}
        disabled={isLoading}
      >
        + Novo Veículo
      </Button>
    </Box>
  );
} 